import React from 'react';
import classnames from 'classnames';

const CheckBox: React.FC<Props> = (props) => (
	<label className="_relative _flex _items-center _justify-start">
		<div className="_flex _items-center _justify-center _flex-shrink-0 _w-6 _h-6 _border-2 _border-gray-400 _rounded focus-within:_border-blue-500">
			<input type="checkbox" className="_absolute _opacity-0" onClick={props.onClick} />
			<svg
				className={classnames('_w-4 _h-4 _text-green-500 _pointer-events-none _fill-current', {
					_hidden: !props.checked,
				})}
				viewBox="0 0 20 20"
			>
				<path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
			</svg>
		</div>
		{props.label && <div className={classnames('_ml-2 _select-none', props.className)}>{props.label}</div>}
	</label>
);

export default CheckBox;

interface Props {
	className?: string;
	checked?: boolean;
	label?: string | JSX.Element;
	onClick?: () => void;
}

CheckBox.defaultProps = {
	className: '',
	checked: false,
	label: undefined,
	onClick: undefined,
};
